import _                                  from 'underscore';
import React, { FC, useEffect, useState } from 'react';
import { Icon, SemanticICONS }            from 'semantic-ui-react';
import { Cell, Grid }                     from 'styled-css-grid';

import { formatOption }                                                    from '@src/util';
import { CorvalMilestone, CorvalUIColor, SemanticUIColor, SemanticUISize } from '@src/types';
import { QueriedSelectFieldProps, SelectField }                            from '@src/views/components/forms';
import { useQuery }                                                        from '@apollo/react-hooks';
import { DecisionEngineQueries }                                           from '@src/queries';
import { queriesHaveData, queriesLoading }                                 from '@src/store/_apolloUtil';
import { ProjectQueries }                                                  from '@src/queries/ProjectQueries';
import { useSystemData }                                                   from '@src/hooks/useSystemData';
import { ProjectService }                                                  from "@src/services";
import { ProjectTimelineDateFieldObject }                                  from "@src/services/ProjectService";
import { useProjectMilestone }                                             from "@src/hooks";
import { ENTITY_ICONS }                                                    from "@src/constants";


interface ProjectMilestonesDropdownProps extends QueriedSelectFieldProps {
    loading?: boolean,
    formatOptions?: object,
    projectId: string,
    projectVersionId?: string,
    allowArchived?: boolean,
    disableArchived?: boolean,
}

const defaultProps: ProjectMilestonesDropdownProps = {
    loading:          false,
    formatOptions:    {},
    projectId:        null,
    projectVersionId: null,
    allowArchived:    false,
    disableArchived:  true,
};

const ProjectMilestonesDropdown: FC<ProjectMilestonesDropdownProps> = ( _props ) => {

    let { formatOptions, projectId, projectVersionId, allowArchived, disableArchived, ...props } = _props;

    const [ milestones, setMilestones ] = useState<ProjectTimelineDateFieldObject[]>( [] );

    const getProjectMilestoneReq = useQuery(
        ProjectQueries.queries.GET_PROJECT( `
                id 
                ${ ProjectQueries.fragments.PROJECTS.TIMELINE_BOUNDARY_FIELDS() }
                ${ ProjectQueries.fragments.PROJECTS.DEFINED_TIMING_FIELDS() }
            ` ), {
            variables:   { order: { name: 'ASC' }, id: projectId },
            fetchPolicy: 'cache-and-network'
        } );

    let isLoading = ( props.loading || queriesLoading( getProjectMilestoneReq ) );

    useEffect( () => {

        if( queriesHaveData( getProjectMilestoneReq ) && queriesHaveData( getProjectMilestoneReq ) ){

            const project = _.first( getProjectMilestoneReq.data.projects );

            let projectMilestones = ProjectService.getTimelineDataObjectFromProject( project, projectVersionId );

            setMilestones( projectMilestones );
        }

    }, [ getProjectMilestoneReq ] );

    let options = milestones.map( ( milestone: ProjectTimelineDateFieldObject ) => {

            const component = (
                <div>
                    <Grid columns={ `auto 1fr` } rows={ `auto` } columnGap={ '10px' }>
                        <Cell middle>
                            <Icon size={ SemanticUISize.SMALL }
                                  name={ milestone.icon as SemanticICONS }
                                  color={ milestone.color as any }
                                  className={ milestone.icon === ENTITY_ICONS.MILESTONES.ITEM ? 'rotate--45' : undefined }
                            />
                        </Cell>
                        <Cell middle>{ milestone.label }</Cell>
                    </Grid>
                </div>
            );

            return formatOption( milestone.id, component )
        }
    );

    return (
        <SelectField
            { ...props }
            search
            loading={ isLoading }
            options={ options }
        />
    );
};

ProjectMilestonesDropdown.defaultProps = defaultProps;

export { ProjectMilestonesDropdown };
